import { readonly, type Ref } from 'vue'
import { AppVisibility } from './app-visibility'

const appVisibility = new AppVisibility()

const initAppVisibility = (): void => appVisibility.init()

const destroyAppVisibility = (): void => appVisibility.destroy()

type UseAppVisibility = {
  appIsVisible: Readonly<Ref<boolean>>
  initAppVisibility: () => void
  destroyAppVisibility: () => void
}

export const useAppVisibility = (): UseAppVisibility => {
  return {
    appIsVisible: readonly(appVisibility.isVisible),
    initAppVisibility,
    destroyAppVisibility,
  }
}
